/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as PublicImport } from './routes/_public'
import { Route as AuthImport } from './routes/_auth'
import { Route as IndexImport } from './routes/index'
import { Route as AccessIdImport } from './routes/access.$id'
import { Route as PublicSignupImport } from './routes/_public/signup'
import { Route as PublicSigninImport } from './routes/_public/signin'
import { Route as AuthSubscribeImport } from './routes/_auth/subscribe'
import { Route as AuthOrganizationProfileImport } from './routes/_auth/organization-profile'
import { Route as AuthDashboardImport } from './routes/_auth/dashboard'
import { Route as AuthAccountStartImport } from './routes/_auth/account-start'
import { Route as AuthResourceIndexImport } from './routes/_auth/resource.index'
import { Route as AuthResourceIdImport } from './routes/_auth/resource.$id'

// Create/Update Routes

const PublicRoute = PublicImport.update({
  id: '/_public',
  getParentRoute: () => rootRoute,
} as any)

const AuthRoute = AuthImport.update({
  id: '/_auth',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const AccessIdRoute = AccessIdImport.update({
  path: '/access/$id',
  getParentRoute: () => rootRoute,
} as any)

const PublicSignupRoute = PublicSignupImport.update({
  path: '/signup',
  getParentRoute: () => PublicRoute,
} as any)

const PublicSigninRoute = PublicSigninImport.update({
  path: '/signin',
  getParentRoute: () => PublicRoute,
} as any)

const AuthSubscribeRoute = AuthSubscribeImport.update({
  path: '/subscribe',
  getParentRoute: () => AuthRoute,
} as any)

const AuthOrganizationProfileRoute = AuthOrganizationProfileImport.update({
  path: '/organization-profile',
  getParentRoute: () => AuthRoute,
} as any)

const AuthDashboardRoute = AuthDashboardImport.update({
  path: '/dashboard',
  getParentRoute: () => AuthRoute,
} as any)

const AuthAccountStartRoute = AuthAccountStartImport.update({
  path: '/account-start',
  getParentRoute: () => AuthRoute,
} as any)

const AuthResourceIndexRoute = AuthResourceIndexImport.update({
  path: '/resource/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthResourceIdRoute = AuthResourceIdImport.update({
  path: '/resource/$id',
  getParentRoute: () => AuthRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthImport
      parentRoute: typeof rootRoute
    }
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PublicImport
      parentRoute: typeof rootRoute
    }
    '/_auth/account-start': {
      id: '/_auth/account-start'
      path: '/account-start'
      fullPath: '/account-start'
      preLoaderRoute: typeof AuthAccountStartImport
      parentRoute: typeof AuthImport
    }
    '/_auth/dashboard': {
      id: '/_auth/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthDashboardImport
      parentRoute: typeof AuthImport
    }
    '/_auth/organization-profile': {
      id: '/_auth/organization-profile'
      path: '/organization-profile'
      fullPath: '/organization-profile'
      preLoaderRoute: typeof AuthOrganizationProfileImport
      parentRoute: typeof AuthImport
    }
    '/_auth/subscribe': {
      id: '/_auth/subscribe'
      path: '/subscribe'
      fullPath: '/subscribe'
      preLoaderRoute: typeof AuthSubscribeImport
      parentRoute: typeof AuthImport
    }
    '/_public/signin': {
      id: '/_public/signin'
      path: '/signin'
      fullPath: '/signin'
      preLoaderRoute: typeof PublicSigninImport
      parentRoute: typeof PublicImport
    }
    '/_public/signup': {
      id: '/_public/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof PublicSignupImport
      parentRoute: typeof PublicImport
    }
    '/access/$id': {
      id: '/access/$id'
      path: '/access/$id'
      fullPath: '/access/$id'
      preLoaderRoute: typeof AccessIdImport
      parentRoute: typeof rootRoute
    }
    '/_auth/resource/$id': {
      id: '/_auth/resource/$id'
      path: '/resource/$id'
      fullPath: '/resource/$id'
      preLoaderRoute: typeof AuthResourceIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/resource/': {
      id: '/_auth/resource/'
      path: '/resource'
      fullPath: '/resource'
      preLoaderRoute: typeof AuthResourceIndexImport
      parentRoute: typeof AuthImport
    }
  }
}

// Create and export the route tree

interface AuthRouteChildren {
  AuthAccountStartRoute: typeof AuthAccountStartRoute
  AuthDashboardRoute: typeof AuthDashboardRoute
  AuthOrganizationProfileRoute: typeof AuthOrganizationProfileRoute
  AuthSubscribeRoute: typeof AuthSubscribeRoute
  AuthResourceIdRoute: typeof AuthResourceIdRoute
  AuthResourceIndexRoute: typeof AuthResourceIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAccountStartRoute: AuthAccountStartRoute,
  AuthDashboardRoute: AuthDashboardRoute,
  AuthOrganizationProfileRoute: AuthOrganizationProfileRoute,
  AuthSubscribeRoute: AuthSubscribeRoute,
  AuthResourceIdRoute: AuthResourceIdRoute,
  AuthResourceIndexRoute: AuthResourceIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface PublicRouteChildren {
  PublicSigninRoute: typeof PublicSigninRoute
  PublicSignupRoute: typeof PublicSignupRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicSigninRoute: PublicSigninRoute,
  PublicSignupRoute: PublicSignupRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '': typeof PublicRouteWithChildren
  '/account-start': typeof AuthAccountStartRoute
  '/dashboard': typeof AuthDashboardRoute
  '/organization-profile': typeof AuthOrganizationProfileRoute
  '/subscribe': typeof AuthSubscribeRoute
  '/signin': typeof PublicSigninRoute
  '/signup': typeof PublicSignupRoute
  '/access/$id': typeof AccessIdRoute
  '/resource/$id': typeof AuthResourceIdRoute
  '/resource': typeof AuthResourceIndexRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '': typeof PublicRouteWithChildren
  '/account-start': typeof AuthAccountStartRoute
  '/dashboard': typeof AuthDashboardRoute
  '/organization-profile': typeof AuthOrganizationProfileRoute
  '/subscribe': typeof AuthSubscribeRoute
  '/signin': typeof PublicSigninRoute
  '/signup': typeof PublicSignupRoute
  '/access/$id': typeof AccessIdRoute
  '/resource/$id': typeof AuthResourceIdRoute
  '/resource': typeof AuthResourceIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/_auth/account-start': typeof AuthAccountStartRoute
  '/_auth/dashboard': typeof AuthDashboardRoute
  '/_auth/organization-profile': typeof AuthOrganizationProfileRoute
  '/_auth/subscribe': typeof AuthSubscribeRoute
  '/_public/signin': typeof PublicSigninRoute
  '/_public/signup': typeof PublicSignupRoute
  '/access/$id': typeof AccessIdRoute
  '/_auth/resource/$id': typeof AuthResourceIdRoute
  '/_auth/resource/': typeof AuthResourceIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | ''
    | '/account-start'
    | '/dashboard'
    | '/organization-profile'
    | '/subscribe'
    | '/signin'
    | '/signup'
    | '/access/$id'
    | '/resource/$id'
    | '/resource'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | ''
    | '/account-start'
    | '/dashboard'
    | '/organization-profile'
    | '/subscribe'
    | '/signin'
    | '/signup'
    | '/access/$id'
    | '/resource/$id'
    | '/resource'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/_public'
    | '/_auth/account-start'
    | '/_auth/dashboard'
    | '/_auth/organization-profile'
    | '/_auth/subscribe'
    | '/_public/signin'
    | '/_public/signup'
    | '/access/$id'
    | '/_auth/resource/$id'
    | '/_auth/resource/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
  AccessIdRoute: typeof AccessIdRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
  AccessIdRoute: AccessIdRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_auth",
        "/_public",
        "/access/$id"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_auth": {
      "filePath": "_auth.tsx",
      "children": [
        "/_auth/account-start",
        "/_auth/dashboard",
        "/_auth/organization-profile",
        "/_auth/subscribe",
        "/_auth/resource/$id",
        "/_auth/resource/"
      ]
    },
    "/_public": {
      "filePath": "_public.tsx",
      "children": [
        "/_public/signin",
        "/_public/signup"
      ]
    },
    "/_auth/account-start": {
      "filePath": "_auth/account-start.tsx",
      "parent": "/_auth"
    },
    "/_auth/dashboard": {
      "filePath": "_auth/dashboard.tsx",
      "parent": "/_auth"
    },
    "/_auth/organization-profile": {
      "filePath": "_auth/organization-profile.tsx",
      "parent": "/_auth"
    },
    "/_auth/subscribe": {
      "filePath": "_auth/subscribe.tsx",
      "parent": "/_auth"
    },
    "/_public/signin": {
      "filePath": "_public/signin.tsx",
      "parent": "/_public"
    },
    "/_public/signup": {
      "filePath": "_public/signup.tsx",
      "parent": "/_public"
    },
    "/access/$id": {
      "filePath": "access.$id.tsx"
    },
    "/_auth/resource/$id": {
      "filePath": "_auth/resource.$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/resource/": {
      "filePath": "_auth/resource.index.tsx",
      "parent": "/_auth"
    }
  }
}
ROUTE_MANIFEST_END */
